import integrationsReducer, {
	initialState as initialIntegration,
} from './integrations.reducer';

export { initialIntegration, integrationsReducer };
